export default function getCurrentCombat(state) {
    const currentCombat = state.combats?.find((c) => c.id === state.currentCombatId);
    if (!currentCombat) {
        throw `There is no current combat`;
    }
    return currentCombat;
}
